<div class="note" *ngIf="note">{{ note }}</div>
<ng-container *ngIf="displayProposalsDayBlocks; else loader">
  <div class="proposals-list" [style.--border-color]="brandColor" [ngStyle]="{ marginTop: note ? '7rem' : '' }">
    <button
      type="button"
      class="more-button earlier"
      [class.hidden]="isCalendarOpen"
      *ngIf="showEarlierOptionsButton"
      (click)="onSeeEarlierOptions()"
      trackable="Edit delivery/change date & time/See more options/earlier">
      See earlier options
    </button>
    <button
      type="button"
      class="more-button earlier"
      [class.hidden]="isCalendarOpen"
      *ngIf="!showEarlierOptionsButton"
      (click)="onOpenCalendar()"
      trackable="Edit delivery/change date & time/See other dates">
      See other dates
    </button>
    <ng-container *ngIf="!isCalendarOpen">
      <div *ngIf="subTitle" class="sub-title">{{ subTitle }}</div>
      <div *ngFor="let block of displayProposalsDayBlocks" class="day-list" [class.was-first]="block.firstInShort">
        <span class="date-header" [class.requested]="block.requestedDate || block.dateBlock?.requestedDate">{{
          block.formattedTime || block.dateBlock?.formattedTime
        }}</span>
        <div class="proposals-for-date" *ngIf="!block.empty && block.dateBlock">
          <button
            *ngFor="let prop of block.dateBlock.summarizedProposals"
            (click)="selectNewProposal(prop)"
            trackable="Edit delivery/change date & time/{{ block.formattedTime || block.dateBlock.formattedTime }},{{
              prop.dayPart
            }}"
            [disabled]="!prop.available && !prop.current"
            [class.current]="prop.current"
            [class.selected]="(prop.proposalId && prop.proposalId === selectedTime) || (!selectedTime && prop.current)">
            <span>{{ prop.time }}</span>
            <span *ngIf="prop.current" class="small">Current delivery time</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              *ngIf="!prop.available && !prop.current">
              <mask
                id="mask0_2782_16875"
                style="mask-type: alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="24">
                <rect width="24" height="24" fill="#D9D9D9" />
              </mask>
              <g mask="url(#mask0_2782_16875)">
                <path
                  d="M12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C12.9 20 13.7667 19.8542 14.6 19.5625C15.4333 19.2708 16.2 18.85 16.9 18.3L5.7 7.1C5.15 7.8 4.72917 8.56667 4.4375 9.4C4.14583 10.2333 4 11.1 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20ZM18.3 16.9C18.85 16.2 19.2708 15.4333 19.5625 14.6C19.8542 13.7667 20 12.9 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C11.1 4 10.2333 4.14583 9.4 4.4375C8.56667 4.72917 7.8 5.15 7.1 5.7L18.3 16.9Z"
                  fill="#BBC6D6" />
              </g>
            </svg>
          </button>
        </div>
        <ng-container
          *ngIf="block.empty"
          [ngTemplateOutlet]="emptyDate"
          [ngTemplateOutletContext]="{
            requested: block.requestedDate || block.dateBlock?.requestedDate,
          }"></ng-container>
      </div>
    </ng-container>
    <button
      type="button"
      class="more-button"
      [class.hidden]="isCalendarOpen"
      *ngIf="showLaterOptionsButton"
      (click)="onSeeLaterOptions()"
      trackable="Edit delivery/change date & time/See more options/later">
      See later options
    </button>
    <button
      type="button"
      class="more-button"
      [class.hidden]="isCalendarOpen"
      *ngIf="!showLaterOptionsButton"
      (click)="onOpenCalendar()"
      trackable="Edit delivery/change date & time/See other dates">
      See other dates
    </button>
    <mat-calendar
      *ngIf="this.isCalendarOpen"
      [minDate]="today"
      [maxDate]="maxDate"
      [headerComponent]="CalendarHeaderComponent"
      class="edit-delivery"
      [style.--arrow-color]="brandColor"
      [style.color]="brandColor"
      (selectedChange)="onSelectDate($event)"></mat-calendar>
  </div>

  <div class="button-container" [style.--brand-color]="brandColor">
    <button
      type="button"
      class="cancel-button"
      trackable="Edit delivery/change date & time/Cancel"
      [style.color]="brandColor"
      [style.background-color]="textColor"
      [style.border-color]="brandColor"
      *ngIf="displayCancelButton"
      (click)="onCancel()">
      Cancel
    </button>
    <button
      type="submit"
      id="submit-changes"
      *ngIf="!isCalendarOpen"
      [disabled]="!selectedTime || loading || wasCurrentSelected"
      (click)="submitChange()"
      [style.color]="textColor"
      [style.background-color]="brandColor">
      Save new delivery time
      <img *ngIf="loading" src="../assets/loading-circle-white-animated.svg" />
    </button>
    <button
      type="button"
      class="cancel-button"
      [style.color]="brandColor"
      [style.background-color]="textColor"
      [style.border-color]="brandColor"
      *ngIf="isCalendarOpen"
      (click)="onCloseCalendar()"
      trackable="Edit delivery/change date & time/Back to time selection">
      <- Back to time selection
    </button>
  </div>
</ng-container>
<ng-template #emptyDate let-requested="requested">
  <div class="empty-date" *ngIf="!requested">No Available options</div>
  <div class="empty-date requested" *ngIf="requested">
    <div>
      No Available options.<br />
      Check previous & following dates
    </div>
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
      <mask
        id="mask0_2420_13935"
        style="mask-type: alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="40"
        height="40">
        <rect y="40" width="40" height="40" transform="rotate(-90 0 40)" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2420_13935)">
        <path
          d="M32.4999 28.032L26.3653 34.1666L20.2414 28.032L21.7158 26.5599L25.3183 30.1731L25.3183 19.033L27.4123 19.033L27.4123 30.1731L31.0256 26.5684L32.4999 28.032ZM27.4924 14.9777C27.4924 15.2831 27.3828 15.5475 27.1637 15.7707C26.9445 15.9941 26.6787 16.1057 26.3662 16.1057C26.0494 16.1057 25.7822 15.9943 25.5646 15.7716C25.347 15.5489 25.2382 15.2848 25.2382 14.9794C25.2382 14.6626 25.3467 14.3954 25.5638 14.1778C25.7808 13.9603 26.0477 13.8515 26.3645 13.8515C26.677 13.8515 26.9431 13.96 27.1628 14.177C27.3826 14.394 27.4924 14.6609 27.4924 14.9777ZM27.4924 9.79617C27.4924 10.1016 27.3828 10.3659 27.1637 10.5892C26.9445 10.8125 26.6787 10.9241 26.3662 10.9241C26.0494 10.9241 25.7822 10.8128 25.5646 10.59C25.347 10.3673 25.2382 10.1033 25.2382 9.79784C25.2382 9.48106 25.3467 9.21387 25.5638 8.99629C25.7808 8.77871 26.0477 8.66992 26.3645 8.66992C26.677 8.66992 26.9431 8.77841 27.1628 8.99542C27.3826 9.21244 27.4924 9.47936 27.4924 9.79617ZM19.7585 11.968L18.3002 13.4401L14.6816 9.81084L14.6816 20.967L12.5876 20.967L12.5876 9.82687L8.97433 13.4316L7.5 11.968L13.6346 5.83337L19.7585 11.968ZM14.7617 30.2022C14.7617 30.5076 14.6503 30.7719 14.4276 30.9952C14.2049 31.2184 13.9408 31.3301 13.6354 31.3301C13.3115 31.3301 13.0425 31.2187 12.8285 30.996C12.6145 30.7733 12.5075 30.5092 12.5075 30.2038C12.5075 29.887 12.6142 29.6198 12.8277 29.4023C13.0411 29.1847 13.3098 29.0759 13.6338 29.0759C13.9391 29.0759 14.2035 29.1844 14.4268 29.4014C14.6501 29.6184 14.7617 29.8854 14.7617 30.2022ZM14.7617 25.0206C14.7617 25.326 14.6503 25.5903 14.4276 25.8136C14.2049 26.0369 13.9408 26.1485 13.6354 26.1485C13.3115 26.1485 13.0425 26.0372 12.8285 25.8145C12.6145 25.5917 12.5075 25.3277 12.5075 25.0223C12.5075 24.7055 12.6142 24.4383 12.8277 24.2207C13.0411 24.0031 13.3098 23.8943 13.6338 23.8943C13.9391 23.8943 14.2035 24.0028 14.4268 24.2198C14.6501 24.4369 14.7617 24.7038 14.7617 25.0206Z"
          fill="#7A89AD" />
      </g>
    </svg>
  </div>
</ng-template>
<ng-template #loader>
  <div class="loader" *ngIf="isPageActive">
    <common-animated-svg [loop]="true" [svgName]="'edit-loader'" [height]="44" [width]="44"></common-animated-svg>
    <span> Finding available time slots... </span>
  </div>
</ng-template>

<common-edit-order-contact-us-button
  *ngIf="displayProposalsDayBlocks"
  [brandColor]="brandColor"
  [trackableText]="'Change date & time'"></common-edit-order-contact-us-button>
